import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Mode } from '../../constants/enums';

const useStyles = makeStyles((theme: Theme) => ({
  ticket: {
    height: '80%',
    width: '100%',
    display: 'flex',
    margin: '0 auto',
  },
  ticketBreadcrumbs: {
    padding: '5px 20px',
  },
  link: {
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' },
  },
  ticketHeader: {
    padding: '0 20px',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
  },
  ticketTimeline: {
    display: 'grid',
    flexDirection: 'column',
    gap: '10px',
    padding: '20px',
    height: '95%',
    overflow: 'hidden',
    boxSizing: 'border-box',
    gridTemplateRows: '1fr 100px',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  ticketTimelineNoInput: {
    display: 'unset !important',
    height: '100% !important',
  },
  form: {
    display: 'flex',
    gap: '10px',
    padding: '20px',
    background: theme.palette.background.paper,
    borderRadius: '10px',
  },
  ticketTimelineList: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
  },
  ticketTimelineItem: {
    display: 'grid',
    gridTemplateColumns: '200px 1fr',
  },
  divider: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  outerCircle: {
    width: '20px',
    minHeight: '20px',
    background: theme.palette.mode === Mode.Dark ? theme.palette.common.white : 'var(--color-primary)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerCircle: {
    width: '20%',
    height: '20%',
    background: theme.palette.mode === Mode.Dark ? theme.palette.common.white : 'var(--color-primary)',
    borderRadius: '50%',
  },
  circle: {
    width: '27px',
    height: '27px',
    background: 'red',
    borderRadius: '50%',
  },
  line: {
    width: '3px',
    height: '100%',
    background: theme.palette.mode === Mode.Dark ? theme.palette.common.white : 'var(--color-primary)',
  },
  ticketTimelineItemList: {
    width: '100%',
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
  },
  ticketNote: {
    borderRadius: '5px',
    width: '100%',
    marginTop: '5px',
  },
  ticketNoteHeader: {
    width: '100%',
    padding: '3px 5px',
    boxSizing: 'border-box',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: 'small',
    display: 'flex',
    justifyContent: 'space-between',
  },
  ticketNoteContent: {
    padding: '20px',
    boxSizing: 'border-box',
    background: theme.palette.background.paper,
    border: '1px solid rgba(128, 128, 128, 0.49)',
    borderRadius: '5px',
    wordBreak: 'break-word',
  },
  ticketInfo: {
    background: theme.palette.background.paper,
    padding: '20px',
    boxSizing: 'border-box',
    maxWidth: '1000px',
    borderRadius: '5px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    margin: '10px',
    overflow: 'hidden',
    height: '100%',
  },
  ticketInfoChat: {
    overflow: 'hidden',
    boxSizing: 'border-box',
    height: '100%',
  },
  ticketInfoChatMessages: {
    height: '100%',
    overflow: 'auto',
  },
  ticketInfoList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  ticketInfoItem: {
    display: 'grid',
    gap: '30px',
    gridTemplateColumns: '150px 1fr',
    alignItems: 'center',
  },
  connectwiseTicketInfo: {
    gridTemplateColumns: '130px 1fr',
  },
  ticketInfoItemKey: {
    display: 'flex',
    alignItems: 'center',
    color: 'grey',
    gap: '20px',
    '& svg': { width: '30px', height: '30px', '& path': { fill: 'grey' } },
  },
  ticketInfoItemDate: {
    display: 'flex',
    justifyContent: 'space-around',
    '& svg': { '& path': { fill: theme.palette.text.primary } },
    color: theme.palette.text.primary,
  },
  noteText: {
    whiteSpace: 'pre-wrap',
    color: theme.palette.text.primary,
    '& p': { fontWeight: 700, margin: '4px 0 0' },
  },
}));

export default useStyles;
